export default __webpack_public_path__ + "static/media/endPoint.8e3d5e76.svg";